module.exports = __webpack_public_path__ + "img/liander_gasleiding.95b5e1a9.png";